import { FC } from 'react';

import { Input } from '@dynamika-shared/ui/Input/Input';
import { SearchSuffix } from '@dynamika-shared/ui/Input/SearchSuffix';
import { NotificationTypes } from '@dynamika-shared/types/subscription';

import { SiteRecipientsEventFilter } from './SiteRecipientsEventFilter';
import {
  SiteRecipientsSiteFilter,
  SiteRecipientsSiteFilterOption,
} from './SiteRecipientsSiteFilter';

export type SiteRecipientsFiltersProps = {
  sites: SiteRecipientsSiteFilterOption[];
  selectedSiteId?: string;
  onSelectedSiteChange: (siteId?: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
  selectedEvents: NotificationTypes[];
  onEventsChange: (events: NotificationTypes[]) => void;
  disabled?: boolean;
};

export const SiteRecipientsFilters: FC<SiteRecipientsFiltersProps> = ({
  sites,
  selectedSiteId,
  onSelectedSiteChange,
  search,
  onSearchChange,
  selectedEvents,
  onEventsChange,
  disabled,
}) => {
  return (
    <div className='mb-3 flex w-full flex-row items-center justify-between gap-2'>
      <SiteRecipientsSiteFilter
        sites={sites}
        selectedSiteId={selectedSiteId}
        onSelectedSiteChange={onSelectedSiteChange}
        disabled={disabled}
      />

      <div className='flex min-w-0 items-center align-baseline gap-1'>
        <SiteRecipientsEventFilter
          selectedEvents={selectedEvents}
          onEventsChange={onEventsChange}
          disabled={disabled}
        />

        {/**
         * Two deliberate omissions here:
         *
         * - No `allowClear`. `SearchSuffix` already renders the clear control
         *   (a magnifier while empty, a cross once typed in); antd's own clear
         *   button would sit beside it as a second cross.
         * - No `disabled` while loading. Every settled keystroke fires a
         *   request, and disabling the field mid-flight makes the browser blur
         *   it — the caret would vanish as the user typed. The table shows the
         *   loading state on its own.
         */}
        <Input
          name='siteRecipientsSearch'
          classNameContainer=''
          className='min-w-[32rem] !rounded-[3.2rem] px-2 !py-0'
          placeholder='Search existing user or add new'
          suffix={
            <SearchSuffix
              disabled={!search}
              action={() => {
                onSearchChange('');
              }}
            />
          }
          value={search}
          onChange={event => onSearchChange(event.target.value)}
        />
      </div>
    </div>
  );
};
